import { RemoteServiceUnitType } from '../../../../operational-data-common/services/units-adapter/units.model';

interface SanitizerConfig {
  unit: RemoteServiceUnitType;
  filters: any[];
}

interface SanitizerFnProperties {
  value: string;
  character: string;
  characterIndex: number;
}

const valueSanitizerConfig: SanitizerConfig[] = [
  {
    unit: RemoteServiceUnitType.Bar,
    filters: [allowIntegerValue, allowNegativeValue, allowDecimalValue],
  },
];

const defaultValueSanitizerConfig: SanitizerConfig = {
  unit: null,
  filters: [allowIntegerValue, allowNegativeValue],
};

/**
 * Takes word as an argument and keeps letters which meet at least one filtering criteria.
 * Filters are selected by unit type
 */
export function sanitizeValue(word: string, unit: RemoteServiceUnitType): string {
  const config = valueSanitizerConfig.find((entry) => entry.unit === unit);
  const filters = config ? config.filters : defaultValueSanitizerConfig.filters;
  const curriedFilters = filters.map((filter) => filter());

  const valueSplit = word.split('');

  const newValue = valueSplit.filter((character, characterIndex) => {
    const properties: SanitizerFnProperties = {
      value: word,
      character,
      characterIndex,
    };
    const passed = curriedFilters.some((sanitizerFilter) => sanitizerFilter(properties));

    return passed;
  });

  return newValue.join('');
}

function allowIntegerValue(): Function {
  return (properties: SanitizerFnProperties): boolean => {
    return Number.isInteger(+properties.character);
  };
}

function allowNegativeValue(): Function {
  return function (properties: SanitizerFnProperties): boolean {
    return properties.character === '-' && properties.characterIndex === 0;
  };
}

function allowDecimalValue(): Function {
  let dotValuePresent = false;

  return function (properties: SanitizerFnProperties): boolean {
    const dotValue = properties.character === '.';

    if (dotValue && !dotValuePresent) {
      dotValuePresent = true;

      return true;
    } else if (dotValue && dotValuePresent) {
      return false;
    }
  };
}
